export function cartContent(data) {
  const $htmlMobile = $(data).find('.mobile-cart').html();
  if ($('body').hasClass('template-cart')) {
    const $htmlDesktop = $(data).find('.desktop-cart').html();
    $('.desktop-cart').empty().html($htmlDesktop);
    $('.mobile-cart').empty().html($htmlMobile);
  }
  $('.cart-reaveal').empty().html($htmlMobile);
}



// WEBPACK FOOTER //
// ../markup/assets/js/cart-content.js